import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../services/auth/auth.service';
import { Subscription } from 'rxjs';
import { LottosService } from '../../../../services/lottos/lottos.service';

@Component({
  selector: 'app-what-is',
  templateUrl: './what-is.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./what-is.component.scss']
})
export class WhatIsComponent implements OnInit {
  public id: number;
  public subs: Subscription;
  constructor(protected lotto: LottosService) {}

  ngOnInit(): void {
    this.setId();
  }

  setId(): void {
    this.subs = this.lotto.lottoObservable$.subscribe((lottoObj) => {
      this.id = lottoObj['id'];
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
